import React from 'react';

import s from './InfoErrorSuccessPopup.module.css';
import errorImage from '../../../assets/img/messageWindow/error.svg';
import syncedImage from '../../../assets/img/messageWindow/synced.svg';
import noStructure from '../../../assets/img/messageWindow/noStructure.svg';
import CommonSvgSelector from '../../../assets/common/SVG/CommonSvgSelector';

type Props = {
	type: 'error' | 'synced' | 'noStructure' | 'megafon';
	text: string;
	close?: (b: boolean) => void;
};
export const InfoErrorSuccessPopup: React.FC<Props> = ({type, text, close}) => {
	const iconMap: Record<string, string> = {
		error: errorImage,
		synced: syncedImage,
		noStructure: noStructure,
	};
	const iconSrc = iconMap[type];
	return (
		<div className={s.wrapper}>
			<div className={s.container}>
				{close && type !== 'noStructure' && (
					<div className={s.crossContainer}>
						<button onClick={() => close(false)}>
							<CommonSvgSelector id="closeCross" />
						</button>
					</div>
				)}
				<div className={s.iconsContainer}>
					{iconSrc && <img src={iconSrc} alt={type} />}
				</div>
				<div className={s.text}>{text}</div>
			</div>
		</div>
	);
};

export default InfoErrorSuccessPopup;
